const screens = process.env.screens && process.env.screens.length > 0 ? process.env.screens : [
    "WORKFLOW", // Quy trình
    "MAP", // Bản đồ
    "CUSTOMER", // Quản lý đối tác
    "ROLE", // Quản lý nội bộ
    "CATEGORY", // Quản lý dữ liệu
    "DASHBOARD", // Báo cáo quản trị
    "USER", // Thông tin cá nhân
];
const certificate_lookup = process.env.certificate_lookup ? process.env.certificate_lookup : false;
export { screens, certificate_lookup };
